const normalizeNumber = value => {
    if (value === null || value === undefined || value === '') return null
    const normalized = String(value).replace(/,/g, '')
    const number = Number(normalized)
    return Number.isNaN(number) ? null : number
}

const sumField = (records, key) => {
    if (!Array.isArray(records) || records.length === 0) return null
    let total = 0
    let hasValue = false
    records.forEach(record => {
        const value = normalizeNumber(record ? record[key] : null)
        if (value !== null) {
            total += value
            hasValue = true
        }
    })
    return hasValue ? total : null
}

export const isTfDetailRecordReceived = record => {
    const receivedMass = normalizeNumber(record ? record.Received : null)
    return receivedMass !== null && receivedMass > 0
}

export const isTfDetailRecordUnreceived = record => {
    const receivedMass = normalizeNumber(record ? record.Received : null)
    return receivedMass === null || receivedMass === 0
}

export const isTfDetailRecordLoaded = record => {
    const dispatchMass = normalizeNumber(record ? record.Dispatched : null)
    return dispatchMass !== null && dispatchMass > 0
}

export const countTfDetailLoadedBales = records => {
    if (!Array.isArray(records) || records.length === 0) return 0
    return records.filter(isTfDetailRecordLoaded).length
}

export const countTfDetailReceivedBales = records => {
    if (!Array.isArray(records) || records.length === 0) return 0
    return records.filter(isTfDetailRecordReceived).length
}

export const buildTfDetailTotalsRow = records => {
    if (!Array.isArray(records) || records.length === 0) return null

    const loadedBalesCount = countTfDetailLoadedBales(records)
    const receivedBalesCount = countTfDetailReceivedBales(records)
    const purchaseTotal = sumField(records, 'purchase_mass')
    const dispatchTotal = sumField(records, 'Dispatched')
    const receivedTotal = sumField(records, 'Received')

    return {
        __summary: true,
        scanner_full_Name: 'Total',
        loaded_at: '',
        MarkedAs: '',
        loaded_bale: loadedBalesCount || '',
        purchase_mass: purchaseTotal === null ? '' : purchaseTotal,
        Dispatched: dispatchTotal === null ? '' : dispatchTotal,
        received_bale: receivedBalesCount || '',
        received_by: '',
        received_at: '',
        Received: receivedTotal === null ? '' : receivedTotal,
    }
}
